import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { C, T } from 'shared/helpers';

import Styles from './EconomiasIndiretas.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons';

import Header from 'components/Header/Header';
import Table from './Table/Table';

import { Creators as reduxPerguntas } from 'store/ducks/perguntas';
import { Creators as reduxRespostas } from 'store/ducks/respostas';
import { Creators as reduxProdutos } from 'store/ducks/produtos';
import { Creators as reduxEtapas } from 'store/ducks/etapas';

import { useEditableContext } from 'shared/hooks';
import PrintButton from 'components/PrintButton/PrintButton';
import WithPermission from 'components/Template/WithPermission/WithPermission';

export default function EconomiasIndiretas({ match }) {
  const { EconomiasIndiretas, Selected, Saver, Hidden } = Styles;
  const { id } = match.params;

  const dispatch = useDispatch();
  const [edit, setEdit] = useState(false);
  const block = useRef(false);

  useEffect(() => {
    dispatch(
      reduxPerguntas.getPerguntas((x) => x.fase_id === 7 || x.fase_id === 8),
    );
    dispatch(reduxEtapas.getEtapas(id));
    dispatch(reduxProdutos.getProdutos());
  }, [id, dispatch]);

  const Perguntas = useSelector((state) => state.perguntas.data);
  const Respostas = useSelector((state) => state.respostas.data);
  const pem = useSelector((state) => state.etapas.pem);

  const perguntas = useCallback(
    () => T(Perguntas, []).filter((x) => x.fase_id === 7),
    [Perguntas],
  );
  const REtapas = useSelector((state) => state.etapas.data);

  useEditableContext(edit);

  useEffect(() => {
    dispatch(
      reduxRespostas.getRespostas(
        (x) =>
          String(x.pem_id) === String(id) &&
          Perguntas.some((y) => String(y.id) === String(x.pergunta_id)),
      ),
    );
  }, [id, dispatch, Perguntas]);

  const [form, setForm] = useState({});

  useEffect(() => {
    const f = {};
    const p = [...(perguntas() || [])];
    p.sort((a, b) => (a.id > b.id ? 1 : -1));
    for (let i = 0; i < perguntas().length; i++) {
      f[perguntas()[i].id] = T(
        T(
          T(Respostas, []).find(
            (x) => String(x.pergunta_id) === String(perguntas()[i].id),
          ),
        ).resposta,
        '',
      );
    }
    setForm({ ...f });
  }, [perguntas, Respostas, edit]);

  useEffect(() => {
    if (edit) {
      block.current = false;
    }
  }, [edit]);

  if (pem !== id) {
    return null;
  }

  const Etapas = REtapas.map((x) => ({
    ...x,
    produtosSQMV: x.produtos.filter((y) => y.fase_id === 2),
    produtosCOND: x.produtos.filter((y) => y.fase_id === 3),
  }));

  const Totals = Etapas.map((etapa) => {
    let totalSQMV = 0;
    let totalCOND = 0;
    for (let i = 0; i < etapa.produtosSQMV.length; i++) {
      totalSQMV += Number(
        (etapa.produtosSQMV[i].valor / 1000) * etapa.produtosSQMV[i].quantidade,
      );
    }
    for (let i = 0; i < etapa.produtosCOND.length; i++) {
      totalCOND += Number(
        (etapa.produtosCOND[i].valor / 1000) * etapa.produtosCOND[i].quantidade,
      );
    }

    return [totalSQMV, totalCOND];
  });

  const haProductivity =
    T(
      T(Respostas, []).find(
        (x) =>
          x.pergunta_id ===
          T(T(Perguntas, []).find((p) => p.code === 'precoUnCultura')).id,
      ),
    ).resposta || 0;

  const send = () => {
    if (block.current) return;
    block.current = true;
    dispatch(
      reduxRespostas.saveRespostas(
        id,
        7,
        { pergunta: form },
        (x) =>
          String(x.pem_id) === String(id) &&
          Perguntas.some((y) => String(y.id) === String(x.pergunta_id)),
      ),
    );
    setEdit(false);
  };

  return (
    <div className={EconomiasIndiretas}>
      <Header title={'ECONOMIAS INDIRETAS'} icon={faHandHoldingUsd}>
        <WithPermission permission='respostas.create'>
          <button
            id='editar'
            className={C([edit, Selected])}
            onClick={() => setEdit(!edit)}
          >
            <FontAwesomeIcon icon={faEdit} />
          </button>
        </WithPermission>
        <PrintButton />
      </Header>
      <Table
        productivityPerHa={Number(haProductivity || 0)}
        totals={Totals}
        perguntas={perguntas()}
        edit={edit}
        form={form}
        setForm={setForm}
        productionUnit={
          T(
            T(Respostas, []).find(
              (r) =>
                T(T(Perguntas, []).find((x) => x.code === 'unidadeProducao'))
                  .id === r.pergunta_id,
            ),
          ).resposta
        }
      />
      <button
        className={C(Saver, [!edit, Hidden])}
        onClick={send}
        id='btn_salvar_respostas'
      >
        Salvar
      </button>
    </div>
  );
}

EconomiasIndiretas.propTypes = {
  match: PropTypes.any.isRequired,
};
